import type { Capability } from '@/lib/permissions';
import type { IconName } from '@/components/ui/Icon';

export interface NavItem {
  label: string;
  path: string;
  icon: IconName;
  /** If set, the item is hidden unless the current role has this capability. */
  capability?: Capability;
}

export interface NavSection {
  heading: string | null;
  items: NavItem[];
}

/** Sidebar + route source of truth. Order and grouping mirror the design. */
export const NAV: NavSection[] = [
  {
    heading: null,
    items: [{ label: 'Overview', path: '/app', icon: 'overview', capability: 'overview:view' }],
  },
  {
    heading: 'Operations',
    items: [
      { label: 'Live Floor', path: '/app/floor', icon: 'floor', capability: 'floor:view' },
      { label: 'Bookings', path: '/app/bookings', icon: 'bookings', capability: 'bookings:manage' },
      { label: 'Customers', path: '/app/customers', icon: 'customers', capability: 'customers:view' },
      { label: 'Membership', path: '/app/membership', icon: 'membership', capability: 'membership:view' },
      { label: 'Food & Bar', path: '/app/food', icon: 'food', capability: 'food:manage' },
      { label: 'Attendance', path: '/app/attendance', icon: 'clock', capability: 'attendance:view' },
      { label: 'Menu Management', path: '/app/menu', icon: 'menu', capability: 'menu:edit' },
      { label: 'Rates', path: '/app/rates', icon: 'rates', capability: 'rates:edit' },
    ],
  },
  {
    heading: 'Analytics',
    items: [
      { label: 'Games', path: '/app/games', icon: 'games', capability: 'reports:view' },
      { label: 'Payments', path: '/app/payments', icon: 'payments', capability: 'payments:view' },
      { label: 'Expenses', path: '/app/expenses', icon: 'expenses', capability: 'expenses:edit' },
      { label: 'Insights', path: '/app/insights', icon: 'insights', capability: 'reports:view' },
      { label: 'Reports', path: '/app/reports', icon: 'reports', capability: 'reports:view' },
    ],
  },
  {
    heading: 'Administration',
    items: [
      { label: 'Team', path: '/app/team', icon: 'team', capability: 'users:approve' },
      { label: 'Settings', path: '/app/settings', icon: 'settings', capability: 'settings:edit' },
    ],
  },
];

/** Flattened path → label lookup for breadcrumbs/titles. */
export const PATH_TITLES: Record<string, string> = Object.fromEntries(
  NAV.flatMap((s) => s.items).map((i) => [i.path, i.label]),
);
